import {Grid, Responsive} from "semantic-ui-react";
import LoadingSpinner from "../containers/LoadingContainer/LoadingSpinner";
import * as React from "react";


export const ViewLoadingSpinner = (props: {active: boolean}) => {
  return (<>
    <Responsive minWidth={961} as={Grid.Column} width={1}>
      <div style={{opacity: (props.active) ? '1.0' : '0.0', width:"100%"}}>
        <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
        </div>
      </div>
    </Responsive>
    <Responsive maxWidth={960}>
      <div style={{opacity: (props.active) ? '1.0' : '0.0', width:"3em", position: "fixed", right: '10px', top: '10px'}}>
        <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em', display:'inline-block'}}><LoadingSpinner/>
        </div>
      </div>
    </Responsive>
    </>);
};
